import React from "react";
import { Button } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import siteConfig from "../../../config";

const StartFileModal = ({ isOpen, setIsOpen, setIsCreateFileOpen }) => {
  const modalData = {
    cpa: {
      title: "Let’s Get Started with Your First Tax File",
      description:
        "Welcome to your CPA portal. To begin, create your first tax file and securely share your documents with your accountant.",
    },
    insurance: {
      title: "Create Your First Insurance File",
      description:
        "Start by setting up your first insurance case. Upload documents and collaborate with your insurance advisor seamlessly.",
    },
    immigration: {
      title: "Begin Your Immigration Journey",
      description:
        "Create your first immigration file to track documents, forms, and stay connected with your consultant throughout the process.",
    },
    default: {
      title: "Create Your First File",
      description: `Welcome to ${siteConfig?.name} - Your Trusted Tax Filing Platform!`,
    },
  };

  const data = modalData[siteConfig?.firmType] || modalData.default;

  return (
    <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} title={data.title}>
      <div className="flex flex-col">
        <div className="flex justify-between items-center w-full">
          <p className="text-base text-Gray text-center">
            {data.description}
          </p>
        </div>

        <div className="text-center mt-8">
          <Button
            type="primary"
            className="uppercase font-medium"
            onClick={() => {
              setIsOpen(false);
              setIsCreateFileOpen(true);
            }}
          >
            <img src="/assets/icons/add.svg" alt="icon" />
            Start File
          </Button>
        </div>
      </div>
    </ModalComponent>
  );
};

export default StartFileModal;
